import { BILLING_LOG_LABELS, BILLING_LOG_LABELS_EN } from './billingData';

const CONSUMPTION_TYPES = new Set([
  'spend', 'consume_script', 'consume_image', 'consume_video',
  'consume_audio', 'consume_review', 'canvas',
]);

export function getCreditLedgerActivity(item, scope = 'personal', english = false) {
  const walletScope = ['personal', 'team'].includes(item?.wallet_scope) ? item.wallet_scope : scope;
  const knownType = Object.prototype.hasOwnProperty.call(BILLING_LOG_LABELS, item?.type);
  const code = item?.activity_type || (CONSUMPTION_TYPES.has(item?.type)
    ? `${walletScope}_consumption`
    : knownType ? item.type : 'other');
  const labels = english ? BILLING_LOG_LABELS_EN : BILLING_LOG_LABELS;
  const label = code === 'personal_consumption'
    ? (english ? 'Personal usage' : '个人消耗')
    : code === 'team_consumption'
      ? (english ? 'Team usage' : '团队消耗')
      : (!english && item?.activity_type_label)
        || (Object.prototype.hasOwnProperty.call(labels, code) && labels[code])
        || (english ? 'Other credit activity' : '其他点数变动');
  return {
    code,
    label,
    scopeLabel: walletScope === 'team'
      ? (english ? 'Team credits' : '团队点数')
      : (english ? 'Personal credits' : '个人点数'),
  };
}
